import React from 'react';
import { SectionCTA } from './SectionCTA';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <section className="bg-ink px-5 py-16 text-white md:py-24" aria-labelledby="pain-title" data-id="element-281" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-5xl" data-id="element-282" data-mp="26xmpyvom1cbd">
        <div className="mx-auto max-w-3xl text-center" data-id="element-283" data-mp="2bxiyn8895rx9">
          <p className="text-sm font-bold uppercase tracking-[0.14em] text-gold" data-id="element-284" data-mp="2bvy2xfa7c2xt">Do any of these situations sound familiar?</p>
          <h2 id="pain-title" className="mt-3 font-display text-3xl font-black leading-tight md:text-5xl" data-id="element-285" data-mp="1xzu9ho75jyme">
            If You Answer <span className="text-gold" data-id="element-286" data-mp="1nztozyxjrcgm">YES</span> to Any of These, TRT Blueprint Was Designed With Your Workflow in Mind.
          </h2>
        </div>

        <ol className="mt-12 grid gap-x-10 gap-y-8 md:grid-cols-2" data-id="element-287" data-mp="1sz6mrepyi3xz">
          {painPoints.map((p, i) => <li key={p.title} className="flex gap-4 border-t border-white/10 pt-6" data-id="element-288" data-mp="3iee5dzeu4lu7" data-mpi={i}>
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand font-display text-xl font-black text-ink" data-id="element-289" data-mp="3nbcvm6vdo8n4">
                {i + 1}
              </span>
              <div data-id="element-290" data-mp="1u0sngopnvvz5">
                <h3 className="font-display text-xl font-extrabold leading-snug" data-id="element-291" data-mp="1u1buvbhor1yx">{p.title}</h3>
                <p className="mt-2 leading-relaxed text-slate-300" data-id="element-292" data-mp="27sgvafsvnyab">{p.text}</p>
              </div>
            </li>)}
        </ol>

        <div className="mx-auto mt-14 max-w-3xl space-y-4 text-center text-lg leading-relaxed text-slate-300" data-id="element-293" data-mp="1g1svp86ur0yr">
          <p data-id="element-294" data-mp="1b39bpdbtjz91">And your reference materials shouldn’t make this harder than it needs to be.</p>
          <p className="font-display text-2xl font-bold leading-snug text-white" data-id="element-295" data-mp="1p291wpezcm7b">
            The problem may not be how much you know. It may be how difficult it is to retrieve and organize the information when you need it.
          </p>
          <p data-id="element-296" data-mp="30gcr7iamhm61">
            That’s why I created TRT Blueprint: to bring the essential educational components of testosterone therapy into one structured, practical reference.
          </p>
        </div>

        <SectionCTA label="Show Me the Complete System" dark data-id="element-297" data-mp="1t4dhh4ipvc9d" />
      </div>
    </section>;
}